module.exports = __webpack_public_path__ + "static/media/dmgardencentre.6f4566b1.png";